import React, {useContext} from 'react';
import Grid from "@mui/material/Grid";
import {RadioGroupQuestion} from "../../../../widgets/inputs/RadioGroupQuestion";
import {
	COMPARSA_SINTOMI, IMMUNODEPRESSO_3a, PATOLOGIE_3a, PRESENTA_SINTOMI_3a, RICOVERATO_3a,
	STRUTTURA_NOME
} from "../../../../../strings/IT";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import {strutture} from "../../../../../utils/dictionaries/StruttureDict";
import {autocompleteRules} from "../../../../../utils/RegisterUtils";
import {ChechBoxMultiQuestion} from "../../../../widgets/inputs/ChechBoxMultiQuestion";
import {immunodepressioni, patologie, sintomi} from "../../../../../utils/arrays/Generics";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import {MonitorStyle} from "../../../../../styles/pages/monitor/MonitorStyle";
import {useFormContext} from "react-hook-form";
import {languages} from "../../../../../strings/LanguageDictionary";
import {AppContext} from "../../../../../App";
import {removeDayDoDate} from "../../../../../utils/GenericUtils";

export const SintomiGrid = ({isRientri = false, isCit = false, dataSintomiReq = true, dataEsito = new Date()}) => {
	const monitorClasses = MonitorStyle();
	const appContext = useContext(AppContext);
	const {errors, control, watch} = useFormContext();
	
	return (
		<React.Fragment>
			{!isRientri && <Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? languages[appContext.state.lang].SINTOMI_RICOVERATO_1a : RICOVERATO_3a}
					name={"ricoverato"}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					error={errors["ricoverato"]}
				/>
			</Grid>}
			{
				watch("ricoverato") === "true" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<CustomAutoComplete
						label={STRUTTURA_NOME}
						control={control}
						options={[...strutture, ""]}
						multiple={false}
						rules={autocompleteRules}
						freeSolo={true}
						name={"strutturaRicovero"}
						error={errors["strutturaRicovero"]}
					/>
				</Grid>
			}
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={(isRientri || isCit) ? languages[appContext.state.lang].SINTOMI_PRESENTA_SINT : PRESENTA_SINTOMI_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"presentaSintomi"}
					error={errors["presentaSintomi"]}
				/>
			</Grid>
			{
				watch("presentaSintomi") === "true" &&
				<React.Fragment>
					<Grid item xs={12} className={monitorClasses.subQuestionStart}>
						<ChechBoxMultiQuestion
							question={""}
							control={control}
							list={sintomi}
						/>
					</Grid>
					<Grid item xs={12} className={monitorClasses.subQuestionEnd}>
						<CustomDateInput
							label={COMPARSA_SINTOMI}
							control={control}
							defaultValue={null}
							maxDate={new Date()}
							minDate={dataSintomiReq ? removeDayDoDate(dataEsito, 5) : null}
							rules={{required: true}}
							name={"dataComparsaSintomi"}
							error={errors["dataComparsaSintomi"]}
						/>
					</Grid>
				</React.Fragment>
			}
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={(isRientri || isCit) ? languages[appContext.state.lang].SINTOMI_IMMUNODEPRESS : IMMUNODEPRESSO_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"immunodepresso"}
					error={errors["immunodepresso"]}
				/>
			</Grid>
			{
				watch("immunodepresso") === "true" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<ChechBoxMultiQuestion
						question={""}
						control={control}
						list={immunodepressioni}
					/>
				</Grid>
			}
			
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={(isRientri || isCit) ? languages[appContext.state.lang].SINTOMI_PATOLOGIE_CRO : PATOLOGIE_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"patologieCroniche"}
					error={errors["patologieCroniche"]}
				/>
			</Grid>
			{
				watch("patologieCroniche") === "true" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<ChechBoxMultiQuestion
						question={""}
						control={control}
						list={patologie}
					/>
				</Grid>
			}
		</React.Fragment>
	);
};
